module.exports = __webpack_public_path__ + "static/media/browse_dapps.2ea3c4b2.png";